export function getCurrency (value: number): string {
  //const lang = navigator.language;
  const res = value.toFixed(2) + ' €';
  // if (lang === 'en' || lang === 'en-US') {
  //   res = value.toFixed(2) + ' $';
  // }
  // if (lang === 'en-GB') {
  //   res = value.toFixed(2) + ' £';
  // }
  return res;
}
